/**
 * The runSmartCart method is a method for open smart cart when
 * rebuy.smartcart.ready listener loaded up, set trigger open
 * on cart icon elements, and set cart item count.
 * @name runSmartCart
 * @kind function
 */
function runSmartCart() {
  document.addEventListener('rebuy:smartcart.ready', () => {
    const dataCartIcon = '[data-cart-icon]';
    document.querySelectorAll(dataCartIcon).forEach((i) => {
      i.addEventListener('click', window.Rebuy.SmartCart.show);
    });
    document.addEventListener('rebuy:cart.change', () => {
      fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const indicator = document.querySelector(".site-header__cart-indicator")
        if(indicator) {
          indicator.textContent = `${data.item_count}`
          if (data.item_count == 0) {
            indicator.classList.add('hidden')
          } else {
            indicator.classList.remove('hidden')
          }
        }
      })
    });
    document.addEventListener('rebuy:smartcart.show', () => document.querySelector('body')?.classList.add('rebuy-smartcart-opened'));
    document.addEventListener('rebuy:smartcart.hide', () => document.querySelector('body')?.classList.remove('rebuy-smartcart-opened'));
  });
}

runSmartCart();